import React from 'react';
import classNames from "classnames";


import './DummyBox.css';


export interface DummyBoxProps {
    width?: string;
    height?: string;
    className?: string;
    type?: 'circle' | 'box';
}

export const DummyBox = (
    {
        width,
        height = '40px',
        type = 'box',
        className,
    }: DummyBoxProps
) => {
    return (
        <div className={classNames({
            'DummyBox': true,
            'DummyBox--circle': type === 'circle',
            [className!]: !!className,
        })}
             style={{
                 width: width,
                 height: height,
             }}
        />
    )
}
